import { useEffect } from 'react';

const VoiceAssistant = () => {
  useEffect(() => {
    const scriptId = 'convrza-srijit-widget';
    if (document.getElementById(scriptId)) return undefined;

    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = 'https://widget.ithr.store/conversa-loader.js';
    script.setAttribute('data-agent', 'agt_8db4f8accd3f46888f65');
    script.setAttribute('data-mode', 'avatar');
    document.body.appendChild(script);

    return () => {
      const existing = document.getElementById(scriptId);
      if (existing && existing.parentNode) {
        existing.parentNode.removeChild(existing);
      }
    };
  }, []);

  return null;
};

export default VoiceAssistant;
